import React, { Component, forwardRef } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { cityActionId, centerActionId, timeSlotActionId, ClientActionId, toastError, razorpayCheckoutUrl, paymentVerificationUrl, toastSuccess, BASE_URL, paymentPortalLink, sessionExpireMessage, tokenInavlidMessage, key_id, key_secret, merchantName, merchantDescription, prefilName, prefilContact, prefilEmail, prefilAddress } from '../../utils/constants'
// import Header from '../../common_components/Header';
import Modal from 'react-bootstrap/Modal';
import { cart_details_action, save_for_later_action, generate_unique_no_action, create_payment_order_action, remove_order_action, payment_action, add_to_cart_action } from '../../actions/bookingDetails_action/cart_action';
import Header from '../../common_components/Header';
import { fill_action } from '../../actions/fillList_action';
import $, { data } from 'jquery'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Navigate } from 'react-router-dom';
import Select from 'react-select';
import moment from 'moment';
import Steps from '../../common_components/booking_details/steps';
import RenderRazorpay from '../payment/payment';
class Cart extends Component {
    constructor(props) {
        super(props)
        this.state = {
            finalList: [],
            cartList: [],
            saveforLaterList: [],
            dateList: [],
            noOfItemsCart: 0,
            noOfItemsSFL: 0,
            leadTime: '',
            is25Open: true,
            isLoading: false,
            isOpen: false,
            userId: '',
            orderId: '',
            paymentType: '',
            ToPayDummy: '',
            ToPay: '',
            customAmt: '',
            isLoadPayment: false,
            encPayload: '',
            // orderId: '',
            changeAmt: 1,
            paymentAccessCode: 'AVVI64IL27CE56IVEC',
            finalCurrency: '',
            currencyErr: false,
            blockedSlots: [],
            onClickid: '',

            orderPaymentDetails: {},
            displayRazorpay: false,
        }
        this.submitfrm = React.createRef()
        this.submitpayment = React.createRef()
        this.change100Amt = this.change100Amt.bind(this)
        // this.onCustomBlur = this.onCustomBlur.bind(this)
        this.change25Amt = this.change25Amt.bind(this)
        this.changeCustomAmt = this.changeCustomAmt.bind(this)
        this.addMore = this.addMore.bind(this)
        this.toggleModal = this.toggleModal.bind(this)
        this.getCartDetails = this.getCartDetails.bind(this)
        this.createCartList = this.createCartList.bind(this)
        this.dateCheck = this.dateCheck.bind(this)
        this.onSaveForLater = this.onSaveForLater.bind(this)
        this.onRemove = this.onRemove.bind(this)
        this.addToCart = this.addToCart.bind(this)
        this.navPayment = this.navPayment.bind(this)
        this.handleCreateOrder = this.handleCreateOrder.bind(this)
        this.handlePaymentResponse = this.handlePaymentResponse.bind(this)
    }

    componentDidMount() {
        // window.scroll(0, 0)

        var accessArr = []
        console.log(JSON.parse(sessionStorage.getItem('UserLoginData')))
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login', this.props.params.status == "cart" && { state: { status: "cart" } })
            }, 500);
        }

        this.setState({
            // centerID: this.props.location.state != null && this.props.location.state.CenterID != null ? this.props.location.state.CenterID : '',
            orderId: this.props.location.state != null && this.props.location.state.OrderID != null ? this.props.location.state.OrderID : '',
            userId: sessionStorage.getItem('userId') == '' || sessionStorage.getItem('userId') == null ? '' : sessionStorage.getItem('userId')
        })

        if (this.props.params.status == "failed") {
            toast.error('There is some problem. Please try again later!', {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
        } else if (this.props.params.status == "invalid") {
            toast.error('Payment Already Process Against This Order', {
                theme: 'colored',
                autoClose: 3000,
                hideProgressBar: true,
            })
        }
        // if (this.props.data == "success") {
        //     toastSuccess('Payment successFull')
        // }
        console.log(JSON.parse(sessionStorage.getItem('UserLoginData')), this.props)
        setTimeout(() => {
            this.getCartDetails()
            console.log(this.props.params)
        }, 200);
    }

    addMore() {
        this.props.navigate('/normalView')
        sessionStorage.removeItem('OrderID')
    }

    navPayment(e) {
        e.preventDefault()
        const { userId, cartList, paymentType, ToPay, finalCurrency, blockedSlots } = this.state
        var bottomLimit = this.state.ToPayDummy * (25 / 100)
        var upperLimit = this.state.ToPayDummy
        if (paymentType == 3 && (bottomLimit >= ToPay || ToPay >= upperLimit)) {
            toastError("custom Amount should be in between 25% and 100%")
            return
        }
        else {
            // this.setState({ isLoading: true })
            // if (blockedSlots.length == 0) {
            var uniqueNo = Date.now()
            var order = cartList[0].OrderID
            console.log(JSON.stringify(uniqueNo))
            var rand1 = Math.random().toFixed(1).slice(2)
            var rand2 = Math.random().toFixed(1).slice(2)
            var rand3 = Math.random().toFixed(1).slice(2)
            var finalUniqueNo = `${uniqueNo}${rand1}${rand2}${rand3}`
            console.log(finalUniqueNo)
            var orderIDList = []
            for (var i = 0; i < this.state.cartList.length; i++) {
                var obj = { orderID: this.state.cartList[i].OrderID }
                orderIDList.push(obj)
            }
            console.log(finalCurrency)
            console.log(orderIDList)
            const paymentType = this.state.paymentType
            // return finalUniqueNo
            this.props.generate_unique_no_action((userId == '' || userId == null) ? null : userId, finalUniqueNo, orderIDList)
                .then((data) => {
                    console.log(data)
                    if (data.error != 1) {
                        var UNIQUENO = finalUniqueNo
                        // var refNoString = JSON.stringify(list)
                        var accessCode = 'AVVI64IL27CE56IVEC'
                        var encRequestRes = ''
                        var order_no = 'qaz234567';
                        var testAmount = `${this.state.ToPay}`;
                        var currency = `${finalCurrency}`
                        var selectedAddress = {
                            name: 'testing',
                            address: 'test address',
                            city: 'test city',
                            pincode: '23456',
                            state: 'state test',
                            phone: '1234567890'
                        }
                        console.log(UNIQUENO)
                        var useremail = 'testemail@gmail.com';
                        var cancel_url = `${BASE_URL}/payment/paymentResponse`
                        var redirect_url = `${BASE_URL}/payment/paymentResponse`;//need to ask to redirect
                        //    var request = `order_id=${order_no}&currency=${currency}&amount=${testAmount}&redirect_url=${redirect_url}&cancel_url=${redirect_url}&language=EN&billing_name=${selectedAddress.name}&billing_address=${selectedAddress.address}&billing_city=${selectedAddress.city}&billing_state=MH&billing_zip=${selectedAddress.pincode}&billing_country=India&billing_tel=${selectedAddress.phone}&delivery_name=${selectedAddress.name}&delivery_address=${selectedAddress.address}&delivery_city=${selectedAddress.city}&delivery_state=${selectedAddress.state}&delivery_zip=${selectedAddress.pincode}&delivery_country=India&delivery_tel=${selectedAddress.phone}&billing_email=${useremail}`
                        var request = {
                            order_id: `${UNIQUENO}`,
                            currency: `${currency}`,
                            amount: `${testAmount}`,
                            redirect_url: `${redirect_url}`,
                            cancel_url: `${redirect_url}`,
                            language: `EN`,
                            billing_name: `${JSON.parse(sessionStorage.getItem('UserLoginData')).UserName}`,
                            billing_address: `${"address"}`,
                            billing_city: `${selectedAddress.city}`,
                            billing_state: `MH`,
                            billing_zip: `${selectedAddress.pincode}`,
                            billing_country: `India`,
                            billing_tel: `${selectedAddress.phone}`,
                            delivery_name: `${selectedAddress.name}`,
                            delivery_address: `${selectedAddress.address}`,
                            delivery_city: `${selectedAddress.city}`,
                            delivery_state: `${selectedAddress.state}`,
                            delivery_zip: `${selectedAddress.pincode}`,
                            delivery_country: `India`,
                            delivery_tel: `${selectedAddress.phone}`,
                            billing_email: `${JSON.parse(sessionStorage.getItem('UserLoginData')).Email}`,
                            merchant_param1: `${UNIQUENO}`,
                            merchant_param2: `${parseFloat(paymentType)}`,
                            merchant_param3: `${JSON.parse(sessionStorage.getItem('UserLoginData')).UserID}`,
                            merchant_param4: `${cartList[0].centerName}`,
                            merchant_param5: `${parseFloat(0)}`
                        }
                        //merchant_id=772755&

                        const orderParams = {
                            order_id: 8765432,
                            currency: 'INR',
                            amount: '1',
                            billing_name: 'Sunil',
                            // etc etc
                        };
                        var mapData = {
                            'orderParams': request
                        }
                        console.log(mapData)
                        this.props
                            .payment_action(mapData)
                            .then((data) => {
                                if (data != null) {
                                    console.log("payment response : ", data)

                                    this.setState({ encPayload: data.data })
                                    setTimeout(() => {
                                        this.submitfrm.current.submit()
                                        // this.props.navigate('/payment', { state: { encPayload: this.state.encPayload, } })
                                    }, 200);
                                } else {

                                    this.setState({ isLoading: false })
                                    toast.error('There is some problem. Please try again later!', {
                                        theme: 'colored',
                                        autoClose: 3000,
                                        hideProgressBar: true,
                                    })
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                                this.setState({ isLoading: false })
                            });
                    }
                    else {

                        toastError(data.msg)
                        setTimeout(() => {
                            this.getCartDetails()
                        }, 200);
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
            // }
            // else {
            //     toastError("order not available")
            // }
        }
    }

    getCartDetails() {
        window.scroll(0, 0)
        const { userId, orderId } = this.state
        this.setState({ isLoading: true })

        this.props.cart_details_action((userId == '' || userId == null) ? null : userId, (orderId == '' || orderId == null) ? null : orderId)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.createCartList(data.data)
                    setTimeout(() => {
                        this.dateCheck()
                        this.setState({ isLoading: false })
                    }, 300)
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    createCartList(data) {
        const { dateList, currencyErr, orderId } = this.state

        var orderIDList = []
        var finalList = []
        console.log(data)
        this.setState({ leadTime: data.leadtime })

        // for (var i = 0; i < data.orderArr.length; i++) {
        //     for (var j = 0; j < data.orderArr.length - i - 1; j++) {
        //         var id1 = data.orderArr[i].OrderID
        //         var id2 = data.orderArr[j + 1].OrderID
        //         if (dateA > dateB) {
        //             var tempBookinglist = bookingList[j]
        //             var tempSelectedList = selectedIDList[j]
        //             var tempBlockCalenderList = BlockCalenderList[j]
        //             bookingList[j] = bookingList[j + 1]
        //             selectedIDList[j] = selectedIDList[j + 1]
        //             BlockCalenderList[j] = BlockCalenderList[j + 1]
        //             bookingList[j + 1] = tempBookinglist
        //             selectedIDList[j + 1] = tempSelectedList
        //             BlockCalenderList[j + 1] = tempBlockCalenderList
        //         }
        //     }
        // }

        //create final list
        for (var i = 0; i < data.orderArr.length; i++) {
            var summaryArr = []
            var additionalServicesArr = []
            var objectID = {}
            if (!orderIDList.includes(data.orderArr[i].OrderID)) {
                var ID = data.orderArr[i].OrderID
                orderIDList.push(data.orderArr[i].OrderID)
                for (var j = 0; j < data.orderArr.length; j++) {
                    if (ID == data.orderArr[j].OrderID) {
                        summaryArr.push(data.orderArr[j])
                        objectID.centerName = data.orderArr[j].Name
                        objectID.centerAdd = data.orderArr[j].AddressLine1
                        objectID.centerCity = data.orderArr[j].CityName
                        objectID.currency = data.orderArr[j].Currency
                        if (data.orderArr[j].Filepath != null && data.orderArr[j].Filepath != '') {
                            objectID.centerPics = data.orderArr[j].Filepath.split(',')[0]
                        }
                    }
                }
                for (var j = 0; j < data.AdditionalSerivcesArr.length; j++) {
                    if (ID == data.AdditionalSerivcesArr[j].OrderID) {
                        additionalServicesArr.push(data.AdditionalSerivcesArr[j])
                    }
                }
                console.log('finalfinalList', data.PriceArr)
                for (var j = 0; j < data.PriceArr.length; j++) {
                    if (ID == data.PriceArr[j].OrderID) {
                        objectID.Price = data.PriceArr[j]
                        objectID.membership = data.PriceArr[j].IS_Membership
                    }
                }
                objectID.OrderID = data.orderArr[i].OrderID
                objectID.summary = summaryArr
                objectID.additionalServices = additionalServicesArr
                finalList.push(objectID)
            }
        }
        var finalfinalList = finalList.reverse()
        console.log('finalfinalList', finalfinalList)
        //finallist changes
        var topay = 0
        var saveForLater = []
        var cartList = []
        //create cart and SFL lists
        for (var b = 0; b < finalfinalList.length; b++) {
            if (finalfinalList[b].summary[0].Is_SaveForLater == 1) {
                saveForLater.push(finalfinalList[b])
            }
            else {
                cartList.push(finalfinalList[b])
            }
        }

        //getting dates for disable 25%
        cartList.map((dat) => (
            dat.summary.map(date => (
                dateList.push((date.BookingDate))
            ))
        ))
        console.log(cartList)

        var currencyArr = []
        //to get current order on top
        for (var a = 0; a < cartList.length; a++) {
            console.log('==', cartList[a].Price.Total)
            topay = topay + cartList[a].Price.Total
        }

        for (var a = 0; a < cartList.length; a++) {
            if (cartList[a].OrderID == orderId) {
                var fromIndex = a
                var element = cartList.splice(fromIndex, 1)
                // console.log(element)
                cartList.splice(0, 0, element[0])
            }
        }


        //currency check and blocked check

        for (var a = 0; a < cartList.length; a++) {
            console.log(cartList[a])
            if (!currencyArr.includes(cartList[a].currency)) {
                console.log(cartList[a].currency)
                currencyArr.push(cartList[a].currency)
            }
            // for (var b = 0; b < cartList[a].summary.length; b++) {
            //     if (cartList[a].summary[b].Is_Blocked == 1) {
            //         this.state.blockedSlots.push(cartList[a].summary[b])
            //     }
            // }
        }
        // console.log(this.state.blockedSlots)

        if (currencyArr.length == 1) {
            this.setState({ finalCurrency: currencyArr[0] })
            this.setState({ currencyErr: false })
        }
        else {
            this.setState({ currencyErr: true })
        }
        console.log(currencyArr, currencyErr)


        setTimeout(() => {
            this.setState({ finalList: finalfinalList })
            this.setState({ noOfItemsCart: cartList.length })
            this.setState({ noOfItemsSFL: saveForLater.length })
            this.setState({ ToPay: topay, ToPayDummy: topay })
            this.setState({ cartList: cartList })
            this.setState({ saveforLaterList: saveForLater })

            console.log(finalfinalList)
            console.log(saveForLater)
            console.log(cartList)
        }, 200);
    }


    dateCheck() {
        var flag = true
        const { dateList, leadTime } = this.state
        var today = new Date()
        for (var i = 0; i < dateList.length; i++) {
            var latestDate = new Date(moment(dateList[i]).format('YYYY-MM-DD'))
            var diff = Math.floor((latestDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24))
            console.log(dateList, diff, leadTime)
            if (diff < leadTime) {
                flag = false
                console.log(dateList[i])
                break;
            }
            else {
                flag = true
            }
        }
        if (flag == false) {
            this.setState({ is25Open: false })
        }
        else {
            this.setState({ is25Open: true })
        }
        console.log(flag)
    }

    toggleModal(id) {
        const { isOpen, onClickid } = this.state
        this.setState({ isOpen: !isOpen, onClickid: id })
        console.log(this.state.isOpen, id)
    }

    onSaveForLater(orderID) {
        const { userId, orderId } = this.state
        console.log(orderID)
        this.setState({ isLoading: true })
        this.props.save_for_later_action((userId == '' || userId == null) ? null : userId, orderID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({
                        finalList: [],
                        cartList: [],
                        saveforLaterList: [],
                        dateList: [],
                        paymentType: '',
                        blockedSlots: [],

                    })
                    this.getCartDetails()

                    setTimeout(() => {
                        toastSuccess("Saved for later Successfully")
                        this.setState({ isLoading: false, isOpen: false })
                    }, 300)
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false, isOpen: false })
                        toastError(data.msg)
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onRemove(orderID) {
        const { userId, orderId } = this.state
        console.log(orderID)
        this.setState({ isLoading: true })
        this.props.remove_order_action((userId == '' || userId == null) ? 1 : userId, orderID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({
                        finalList: [],
                        cartList: [],
                        saveforLaterList: [],
                        dateList: [],
                        paymentType: '',
                        blockedSlots: []
                    })
                    this.getCartDetails()

                    setTimeout(() => {
                        toastSuccess("Removed from Cart Successfully")
                        this.setState({ isLoading: false })
                    }, 300)
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    addToCart(orderID) {
        const { userId, orderId } = this.state
        console.log(orderID)
        this.setState({ isLoading: true })
        this.props.add_to_cart_action((userId == '' || userId == null) ? 1 : userId, orderID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({
                        finalList: [],
                        cartList: [],
                        saveforLaterList: [],
                        dateList: [],
                        paymentType: '',
                        blockedSlots: []
                    })
                    this.getCartDetails()

                    setTimeout(() => {
                        toastSuccess("Added to Cart Successfully")
                        this.setState({ isLoading: false })
                    }, 300)
                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/normalView')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    change25Amt() {
        if (this.state.changeAmt != 0) {
            var amt = this.state.ToPayDummy * (25 / 100)
            this.setState({ ToPay: amt, changeAmt: 0 })
        }
        this.setState({ paymentType: 1 })
    }

    change100Amt() {
        if (this.state.changeAmt != 1) {
            var amt = this.state.ToPayDummy
            this.setState({ ToPay: amt, changeAmt: 1 })
        }
        this.setState({ paymentType: 2 })
    }

    changeCustomAmt() {
        this.setState({ ToPay: '', })
        this.setState({ paymentType: 3, changeAmt: 2 })
    }


    async handleCreateOrder(e) {
        e.preventDefault();
        const { userId, cartList, paymentType, ToPay, finalCurrency, blockedSlots, ToPayDummy } = this.state;
        try {
            // Calculate limits for custom payment
            const bottomLimit = ToPayDummy * 0.25;
            const upperLimit = ToPayDummy;
            // Validate custom payment for paymentType 3
            if (paymentType === 3 && (ToPay < bottomLimit || ToPay > upperLimit)) {
                toastError("Custom amount should be between 25% and 100% of the total.");
                return;
            }
            // Prepare orderIDList
            const orderIDList = cartList.map(item => ({ orderID: item.OrderID }));
            // Validate required fields
            if (orderIDList.length === 0 || !ToPay || !finalCurrency) {
                toastError("Invalid payment details. Please check your input.");
                return;
            }
            // Begin creating the order
            this.setState({ isLoading: true });
            const data = await this.props.create_payment_order_action(
                ToPay,
                finalCurrency,
                orderIDList,
                paymentType === 2 ? 0 : 1,
                0,
                'Initiated'
            );
            if (data.error !== 1) {
                this.setState({
                    orderId: data.order_id,
                    orderPaymentDetails: {
                        orderId: data.order_id,
                        currency: data.currency,
                        amount: data.amount,
                    }
                }, () => {
                    setTimeout(() => {
                        this.submitpayment.current.submit();
                        console.log(this.state.orderPaymentDetails);
                    }, 200);
                });
            } else {
                this.setState({ isLoading: false });
                toastError("Something went wrong while processing your order.");
            }
        } catch (err) {
            console.error("Error creating payment order:", err);
            this.setState({ isLoading: false });
            toastError("Not able to create order. Please try again!");
        }
    }



    handlePaymentResponse = (response) => {
        this.setState({ isLoading: false, displayRazorpay: false, });
        if (response == 'Cancelled') {
            toastError("Payment Cancelled")
        }
        else if (response == 'timedout') {
            toastError("Session TimeOut")
        }
        else if (response == 'Cancelled') {
            toastError("Payment failed")
        }
        else {
            toastError("Something went wrong...")
        }
        console.log("Payment response received from child:", response);
    };


    render() {
        const { isLoading, finalCurrency, orderId, encPayload, blockedSlots, paymentAccessCode, cartList, paymentType, leadTime, subTotal, saveforLaterList, noOfItemsSFL, GstTotal, ToPay, is25Open, finalList, noOfItemsCart, isOpen, displayRazorpay, orderPaymentDetails } = this.state
        return (

            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <main id="main">

                    <Header data={[2]} />
                    <section style={{ marginTop: '115px' }}>
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="md-stepper-horizontal orange">
                                        <Steps data={6} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section style={{ minHeight: "83vh" }}>
                        {/* {blockedSlots.length != 0 && <div class="BookiingSlotFull_msg p-0">
                            <div class="row p-0 m-0">
                                <div class="col-md-12 p-0 text-center">
                                    <h6>The booking date and slots that you have shortlisted earlier seems to be unavailable. You need to revisit the booking date and slot, and choose from the available list. <i class="fa fa-exclamation"></i> </h6>
                                </div>
                            </div>
                        </div>} */}
                        <div class="container-fluid">
                            <div class="row">
                                {noOfItemsCart > 0 &&
                                    <div class="col-md-8">
                                        <h6>My Cart ({noOfItemsCart} {noOfItemsCart == 1 ? 'item' : 'items'} )</h6>

                                        {cartList.length > 0 && cartList.map((data) => (
                                            <div class="card product custom_product_card">
                                                <div class="card-body">
                                                    <div class="row gy-3">
                                                        <div class="col-sm-auto">
                                                            <div class="avatar-lg bg-light rounded p-1">
                                                                <img src={data.centerPics} alt="" class="img-fluid d-block card_img" />
                                                            </div>
                                                        </div>
                                                        <div class="col-sm">
                                                            <div className='hallNameLocation'>
                                                                <h5 class="text-truncate head_text"><a class="text-dark">{data.centerName}</a></h5>
                                                                <p class="text-muted Address_para"><i class="fa fa-map"></i> {data.centerAdd}, {data.centerCity}</p>
                                                            </div>
                                                            <div class="">
                                                                <div class="row mr_0">
                                                                    <div class="col-md-12 padding_0">
                                                                        <div class="slot_para">
                                                                            <h6>Summary</h6>
                                                                            <div class="row mr_0">
                                                                                <div class="col-md-3 col-3 pr-1 pl-0">
                                                                                    <span><strong>Booking Date</strong></span>
                                                                                </div>
                                                                                <div class="col-md-5 col-3 padding_0">
                                                                                    <span><strong>Booking Slot</strong></span>
                                                                                </div>
                                                                                <div class="col-md-2 col-3 padding_0 text_center_xs">
                                                                                    <span><strong>Hours</strong></span>
                                                                                </div>
                                                                                <div class="col-md-2 col-3 padding_0 ">
                                                                                    <span><strong>Amount</strong></span>
                                                                                </div>
                                                                            </div>
                                                                            {data.summary.map((sum) => (
                                                                                <div class="row mr_0">
                                                                                    <div class="col-md-3 col-3 pr-1 pl-0">
                                                                                        <span>{moment(sum.BookingDate).format('MMMM Do YYYY')}
                                                                                            {/* {sum.Is_Blocked == 1 && <i class="fa fa-exclamation-circle exclamationColor"></i>} */}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div class="col-md-5 col-3 padding_0">
                                                                                        <span>{sum.BookingSlot}</span>
                                                                                    </div>
                                                                                    <div class="col-md-2 col-3 padding_0 text_center_xs">
                                                                                        <span>{sum.Selectedhrs}</span>
                                                                                    </div>
                                                                                    <div class="col-md-2 col-3 padding_0">{
                                                                                        // data.membership == 1 ? <span>{data.currency == "INR" ? '₹' : '$'}{(parseFloat(sum.NetAmount).toLocaleString("en-IN"))} <del class="text-danger">{data.currency == "INR" ? '₹' : '$'}{(parseFloat(sum.GrossAmount).toLocaleString("en-IN"))}</del></span> :
                                                                                        <span>{data.currency == "INR" ? '₹' : '$'} {(parseFloat(sum.GrossAmount).toLocaleString("en-IN"))}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>

                                                                    {/* <div class="col-md-6">
                                                                        {data.additionalServices.length > 0 &&
                                                                            <div class="add_service_para">
                                                                                <h6>Additional Services</h6>
                                                                                <div class="row mr_0">
                                                                                    <div class="col-md-6 padding_0">
                                                                                        <span><strong>Services</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Type</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Quantity</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Amount</strong></span>
                                                                                    </div>
                                                                                </div>
                                                                                {data.additionalServices.map((addSer) => (addSer.Services != null && <>
                                                                                    <div class="row mr_0">
                                                                                        <div class="col-md-6 padding_0">
                                                                                            <span>{addSer.Services}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{addSer.Type == 'P' ? 'Premium' : 'Standard'}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{addSer.Quantity == 0 || addSer.Quantity == null || addSer.Quantity == '' ? '-' : addSer.Quantity}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{data.currency == "INR" ? '₹' : '$'} {(parseFloat(addSer.GrossAmount).toLocaleString("en-IN"))}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                                ))}
                                                                            </div>
                                                                        }
                                                                    </div> */}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-auto card_price">
                                                            <div class="text-lg-end">
                                                                <p class="text-muted mb-1">Price:</p>
                                                                <h5 class="fs-14">{data.currency == "INR" ? '₹' : '$'} <span id="ticket_price" class="product-price">{(parseFloat(data.Price.Price).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="row align-items-center gy-3">
                                                        <div class="col-sm col-12 RemoveAndSaveForLater">
                                                            <div class="d-flex flex-wrap my-n1 mt-5">
                                                                <div className='Remove_card mt-5 mb-n5'>
                                                                    <a style={{ cursor: 'pointer' }} onClick={() => this.onRemove(data.OrderID)} class="d-block text-body p-1 px-2" ><i class="ri-delete-bin-fill text-muted align-bottom me-1"></i> Remove this Application</a>

                                                                    <a style={{ cursor: 'pointer' }} class="d-block text-body p-1 px-2" onClick={() => this.toggleModal(data.OrderID)} >
                                                                        <i class="ri-bookmark-line text-muted align-bottom me-1 "></i> Save this Application</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-auto col-12 small_summary_div">
                                                            {data.Price.DiscountAmount != null && data.Price.DiscountAmount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Discount Amount</div>
                                                                <h5 class="fs-14 mb-0 text-danger">-{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.DiscountAmount).toLocaleString("en-IN"))}</span></h5>
                                                            </div>}
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">(A) Net Amount</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.NetAmount).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            {data.Price.AdditionalHourCharges != null && data.Price.AdditionalHourCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Additional hour Charges</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalHourCharges != null ? (parseFloat(data.Price.AdditionalHourCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.OvernightCharges != null && data.Price.OvernightCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Overnight Charges</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.OvernightCharges != null ? (parseFloat(data.Price.OvernightCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.AdditionalDiscount != null && data.Price.AdditionalDiscount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Additional Discount</div>
                                                                <h5 class="fs-14 mb-0 text-danger">-{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalDiscount != null ? (parseFloat(data.Price.AdditionalDiscount).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.AdditionalServicesTotal != null && data.Price.AdditionalServicesTotal != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">(B) Additional Services Total</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalServicesTotal != null ? (parseFloat(data.Price.AdditionalServicesTotal).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">GST ( 18% )</div>
                                                                <h5 class="fs-14 mb-0 mr-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.GST).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100" style={{ whiteSpace: "nowrap" }}>{data.Price.AdditionalServicesTotal != null && data.Price.AdditionalServicesTotal != 0 ? '(C)' : '(B)'}Refundable Security Deposit</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.SecurityDeposit).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Total</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.Total).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        ))}
                                        <hr />
                                    </div>
                                }
                                {console.log('noOfItemsCart', noOfItemsCart)}
                                {
                                    noOfItemsCart > 0 &&
                                    <div class="col-md-4">
                                        <div style={{ position: 'sticky', top: '85px' }} >
                                            <div class="sticky-side-div" data-toggle="affix">
                                                <h6 className='And_nbsp_label'>&nbsp;</h6>
                                                <div class="card">
                                                    <div class="card-header border-bottom-dashed">
                                                        <h5 class="card-title mb-0">Order Summary</h5>
                                                    </div>
                                                    {this.state.currencyErr == true ? <p className='text-danger ml-3'><br /> Orders with same currency, can only be processed together.</p> :
                                                        <div class="card-body pt-2">
                                                            <div class="table-responsive">
                                                                <table class="table table-borderless mb-0">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td colSpan={2} style={{ padding: '10px 0px' }}>
                                                                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                                                                    <div style={{ width: '33%', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <div class={!is25Open ? `custom_radio_off` : 'custom_radio'}  >
                                                                                            <label  >
                                                                                                <input

                                                                                                    disabled={!is25Open}
                                                                                                    checked={paymentType == 1} onClick={this.change25Amt} type="radio" name="radio" />

                                                                                                <span style={{}}>25% Advance</span>
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ width: '33%', alignItems: 'center', justifyContent: 'center' }}>
                                                                                        <div class="custom_radio">
                                                                                            <label>
                                                                                                <input checked={paymentType == 2} onClick={this.change100Amt} type="radio" name="radio" />
                                                                                                <span>Full Payment</span>
                                                                                            </label>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style={{ width: '33%' }}>
                                                                                        <div class="custom_radio">
                                                                                            <label>
                                                                                                <input checked={paymentType == 3} onClick={this.changeCustomAmt} type="radio" name="radio" />
                                                                                                <span>Custom Payment</span>
                                                                                            </label>
                                                                                        </div>
                                                                                        {paymentType == 3 && <input type="text" value={this.state.ToPay} class="form-control" onInput={(e) => this.setState({ ToPay: e.target.value })} />}
                                                                                    </div>
                                                                                </div>

                                                                                {!is25Open && <p className='text-danger mt-n2 mb-n1'> <br /> *100% payment applicable to booking within {leadTime} days time period.</p>
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                        <tr>

                                                                        </tr>
                                                                        <tr class="table-active">
                                                                            <th>To Pay {finalCurrency == "INR" ? 'INR' : 'USD'} :</th>
                                                                            <td class="text-end">
                                                                                <span class="fw-semibold" id="cart-total">
                                                                                    {finalCurrency == "INR" ? '₹' : '$'}{((ToPay).toLocaleString("en-IN"))}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    }
                                                </div>

                                                <div class=" form-group mt-3">

                                                </div>
                                                <div class="row mr_0">
                                                    <div class="col-md-12 padding_0 my_buttons">
                                                        <a onClick={this.addMore} class="btn btn-secondary custom_btn add_more_btn"><i class="fa fa-plus"></i> Add More</a>
                                                        {/* for ccavenue */}
                                                        {/* <form onSubmit={this.navPayment} ref={this.submitfrm} id="nonseamless" method="post" name="redirect" action={paymentPortalLink}>
                                                            <input type="hidden" id="encRequest" name="encRequest"
                                                                value={encPayload} />
                                                            <input type="hidden" name="access_code" id="access_code"
                                                                value={paymentAccessCode} />
                                                            <button class="btn btn-success btn-label right ms-auto" disabled={this.state.paymentType == '' || this.state.paymentType == null || ToPay == 0 || this.state.currencyErr == true
                                                            }>
                                                                <a ><i class="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i> Checkout</a>
                                                            </button>
                                                        </form> */}

                                                        {/* for RazorPay */}

                                                        {/* <button class="btn btn-success btn-label right ms-auto" onClick={(e) => this.handleCreateOrder(e)} disabled={this.state.paymentType == '' || this.state.paymentType == null || ToPay == 0 || this.state.currencyErr == true
                                                        }>
                                                            <a ><i class="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i> Checkout</a>
                                                        </button> */}

                                                        <form method="POST"
                                                            //  onSubmit={(e)=>this.handleCreateOrder(e)}
                                                            action={razorpayCheckoutUrl}
                                                            ref={this.submitpayment}
                                                        >
                                                            <input type="hidden" name="key_id" value={key_id} />
                                                            <input type="hidden" name="amount" value={ToPay} />
                                                            <input type="hidden" name="order_id" value={orderId} />
                                                            <input type="hidden" name="name" value={merchantName} />
                                                            <input type="hidden" name="description" value={merchantDescription} />
                                                            <input type="hidden" name="prefill[name]" value={prefilName} />
                                                            <input type="hidden" name="prefill[contact]" value={prefilContact} />
                                                            <input type="hidden" name="prefill[email]" value={prefilEmail} />
                                                            <input type="hidden" name="notes[shipping address]" value={prefilAddress} />
                                                            <input type="hidden" name="callback_url" value={paymentVerificationUrl} />
                                                            <input type="hidden" name="cancel_url" value={paymentVerificationUrl} />
                                                            <input type="hidden" name="notes" value={{ 'key': 'test' }} />
                                                            <button class="btn btn-success btn-label right ms-auto"
                                                                onClick={(e) => this.handleCreateOrder(e)}
                                                                disabled={this.state.paymentType == '' || this.state.paymentType == null || ToPay == 0 || this.state.currencyErr == true
                                                                }>
                                                                <a ><i class="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i> Checkout</a>
                                                            </button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                }
                                {noOfItemsSFL > 0 &&
                                    <div class="col-md-8">
                                        <h6>Save For Later ({noOfItemsSFL} {noOfItemsSFL == 1 ? 'item' : 'items'} )</h6>

                                        {saveforLaterList.length > 0 && saveforLaterList.map((data) => (
                                            <div class="card product">
                                                <div class="card-body">
                                                    <div class="row gy-3">
                                                        <div class="col-sm-auto">
                                                            <div class="avatar-lg bg-light rounded p-1">
                                                                <img src={data.centerPics} alt="" class="img-fluid d-block card_img" />
                                                            </div>
                                                        </div>
                                                        <div class="col-sm">
                                                            <h5 class="text-truncate head_text"><a class="text-dark">{data.centerName}</a></h5>
                                                            <p class="text-muted Address_para"><i class="fa fa-map"></i> {data.centerAdd}, {data.centerCity}</p>
                                                            <div class="">
                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="slot_para">
                                                                            <h6>Summary</h6>
                                                                            <div class="row mr_0">
                                                                                <div class="col-md-3 pr-1 pl-0">
                                                                                    <span><strong>Booking Date</strong></span>
                                                                                </div>
                                                                                <div class="col-md-5 padding_0">
                                                                                    <span><strong>Booking Slot</strong></span>
                                                                                </div>
                                                                                <div class="col-md-2 padding_0">
                                                                                    <span><strong>Hours</strong></span>
                                                                                </div>
                                                                                <div class="col-md-2 padding_0">
                                                                                    <span><strong>Amount</strong></span>
                                                                                </div>
                                                                            </div>
                                                                            {data.summary.map((sum) => (
                                                                                <div class="row mr_0">
                                                                                    <div class="col-md-3 pr-1 pl-0">
                                                                                        <span>{moment(sum.BookingDate).format('MMMM Do YYYY')}</span>
                                                                                    </div>
                                                                                    <div class="col-md-5 padding_0">
                                                                                        <span>{sum.BookingSlot}</span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span>{sum.Selectedhrs}</span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">{
                                                                                        // data.membership == 1 ? <span>{data.currency == "INR" ? '₹' : '$'}{(parseFloat(sum.NetAmount).toLocaleString("en-IN"))} <del class="text-danger">{data.currency == "INR" ? '₹' : '$'}{(parseFloat(sum.GrossAmount).toLocaleString("en-IN"))}</del></span> :
                                                                                        <span>{data.currency == "INR" ? '₹' : '$'} {(parseFloat(sum.GrossAmount).toLocaleString("en-IN"))}</span>}
                                                                                    </div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                    </div>

                                                                    {/* <div class="col-md-6">
                                                                        {data.additionalServices.length > 0 &&
                                                                            <div class="add_service_para">
                                                                                <h6>Additional Services</h6>
                                                                                <div class="row mr_0">
                                                                                    <div class="col-md-6 padding_0">
                                                                                        <span><strong>Services</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Type</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Quantity</strong></span>
                                                                                    </div>
                                                                                    <div class="col-md-2 padding_0">
                                                                                        <span><strong>Amount</strong></span>
                                                                                    </div>
                                                                                </div>
                                                                                {data.additionalServices.map((addSer) => (addSer.Services != null && <>
                                                                                    <div class="row mr_0">
                                                                                        <div class="col-md-6 padding_0">
                                                                                            <span>{addSer.Services}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{addSer.Type == 'P' ? 'Premium' : 'Standard'}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{addSer.Quantity == 0 || addSer.Quantity == null || addSer.Quantity == '' ? '-' : addSer.Quantity}</span>
                                                                                        </div>
                                                                                        <div class="col-md-2 padding_0">
                                                                                            <span>{data.currency == "INR" ? '₹' : '$'} {(parseFloat(addSer.GrossAmount).toLocaleString("en-IN"))}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </>
                                                                                ))}
                                                                            </div>
                                                                        }
                                                                    </div> */}


                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-auto card_price">
                                                            <div class="text-lg-end">
                                                                <p class="text-muted mb-1">Price:</p>
                                                                <h5 class="fs-14">{data.currency == "INR" ? '₹' : '$'} <span id="ticket_price" class="product-price">{(parseFloat(data.Price.Price).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="row align-items-center gy-3">
                                                        <div class="col-sm ">
                                                            <div class="d-flex flex-wrap my-n1 mt-5" style={{ bottom: '0' }}>
                                                                <div className='mt-5 mb-n5'>
                                                                    <a style={{ cursor: 'pointer' }} onClick={() => this.onRemove(data.OrderID)} class="d-block text-body p-1 px-2" ><i class="ri-delete-bin-fill text-muted align-bottom me-1"></i> Remove this Application</a>

                                                                    <a style={{ cursor: 'pointer' }} class="d-block text-body p-1 px-2" onClick={() => this.addToCart(data.OrderID)} >
                                                                        <i class="ri-shopping-cart-line"></i> Add to Cart</a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-sm-auto">
                                                            {data.Price.DiscountAmount != null && data.Price.DiscountAmount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Discount Amount</div>
                                                                <h5 class="fs-14 mb-0 text-danger">-{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.DiscountAmount).toLocaleString("en-IN"))}</span></h5>
                                                            </div>}
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">(A) Net Amount</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.NetAmount).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            {data.Price.AdditionalHourCharges != null && data.Price.AdditionalHourCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Additional hour Charges</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalHourCharges != null ? (parseFloat(data.Price.AdditionalHourCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.OvernightCharges != null && data.Price.OvernightCharges != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Overnight Charges</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.OvernightCharges != null ? (parseFloat(data.Price.OvernightCharges).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.AdditionalDiscount != null && data.Price.AdditionalDiscount != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Additional Discount</div>
                                                                <h5 class="fs-14 mb-0 text-danger">-{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalDiscount != null ? (parseFloat(data.Price.AdditionalDiscount).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            {data.Price.AdditionalServicesTotal != null && data.Price.AdditionalServicesTotal != 0 && <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">(B) Additional Services Total</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{data.Price.AdditionalServicesTotal != null ? (parseFloat(data.Price.AdditionalServicesTotal).toLocaleString("en-IN")) : 0}</span></h5>
                                                            </div>}
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">GST ( 18% )</div>
                                                                <h5 class="fs-14 mb-0 mr-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.GST).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100" style={{ whiteSpace: "nowrap" }}>{data.Price.AdditionalServicesTotal != null && data.Price.AdditionalServicesTotal != 0 ? '(C)' : '(B)'}Refundable Security Deposit</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.SecurityDeposit).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                            <div class="d-flex align-items-center gap-2 text-muted" style={{ justifyContent: 'space-between' }}>
                                                                <div class="width_100">Total</div>
                                                                <h5 class="fs-14 mb-0">{data.currency == "INR" ? '₹' : '$'} <span class="product-line-price">{(parseFloat(data.Price.Total).toLocaleString("en-IN"))}</span></h5>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    </div>}
                                {
                                    noOfItemsCart == 0 && <div class={noOfItemsCart == 0 && noOfItemsSFL == 0 ? "col-md-12" : "col-md-4"}>
                                        <div style={{ position: 'sticky', top: '0' }} >
                                            <div class="sticky-side-div" data-toggle="affix">
                                                <h6>&nbsp;</h6>
                                                <div class="card">
                                                    <div class="card-header border-bottom-dashed">
                                                        <h5 style={{ textAlign: 'center' }} class="card-title mb-0">CART IS EMPTY</h5>
                                                    </div>
                                                    <div class="row mr_0">
                                                        <div class="col-md-12 padding_0 my_buttons">
                                                            <a onClick={this.addMore} class="btn btn-secondary custom_btn add_more_btn"><i class="fa fa-plus"></i> Add Items</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                }
                            </div>
                        </div>
                    </section>
                </main >
                <Modal show={isOpen} onHide={this.toggleModal}>
                    {/* {console.log("LLLL")} */}
                    <Modal.Header>
                        {/* <Modal.Title><h4 class="">Note</h4></Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        <div class="row" >
                            <div class="form-group col-md-12">
                                <p>Date can not be blocked till payment.</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div class="row">
                            <div class="col-md-12">
                                <a style={{ marginRight: '10px' }} onClick={this.toggleModal} class="btn save_btn">Cancel</a>
                                <a onClick={() => this.onSaveForLater(this.state.onClickid)} class="btn save_btn">Ok</a>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
                {displayRazorpay && (
                    <RenderRazorpay
                        amount={orderPaymentDetails.amount}
                        currency={orderPaymentDetails.currency}
                        orderId={orderPaymentDetails.orderId}
                        keyId={key_id}
                        keySecret={key_secret}
                        onPaymentResponse={this.handlePaymentResponse}
                    />)
                }
            </>
        )
    }
}

export default withRouter(connect(null, { payment_action, cart_details_action, create_payment_order_action, generate_unique_no_action, add_to_cart_action, save_for_later_action, remove_order_action })(Cart));